window.jh3d_instances = [];

$(function() {
	if ( !Cookies.get("cache_prime") ) {
		frappe.call({
			method: "jhaudio3d.utils.build_cache",
			args: {},
			callback: function() {
				Cookies.set("cache_prime", 1);
			},
			error: function(r) {
				console.log("Error creating designer cache");
			}
		})
	}
});

cart.on('tpl-ready', function() {
	// all .jh3d-binded elements are flagged as already binded
	// so only process those without it.
	$('[data-jhaudio3d-options]:not(.jh3d-binded)').each(function() {
		// flag as binded
		if ( cart.tag ) {
			$(this).fadeOut('fast');
		}
		$(this).addClass('jh3d-binded');
		var tpl_name = $(this).attr('data-template')
		var options_id = $(this).attr('data-jhaudio3d-options')
		var $splash = $($(this).attr('data-jhaudio3d-splash'));
		var default_item_code = $(this).attr('data-sku')
		var show_fps = $(this).attr('data-show-fps') || false;

		var progressTracker = new awc.ProgressTracker();
		progressTracker.on('progress', function(tracker, p, loaded, total) {
			try {
				var percent = (p * 100)+"%";
				$splash.find('.progress .progress-bar').css({'width': percent});
			} catch(ex) {
				console.error(ex);
			}
		})

		// pre-fetch 3d designer html template
		cart.template(tpl_name);
		// pre-fetch 3d designer app
		//awc.require({ url: "/assets/js/libs.min.js", onprogress: progressTracker});
		awc.require({ url: '/assets/jhaudio3d/js/libs/gif.js', onprogress: progressTracker});
		awc.require({ url: '/assets/js/jhaudio3d.js', onprogress: progressTracker, nocache: 1});
		var config_url = '/api/method/jhaudio3d.designer.get_configuration?name=' + options_id;
		if ( cart.tag ) {
			options_id=cart.tag;
			config_url += "&override_name=" + default_item_code + "&override_options=" + cart.tag;
		} else {
			config_url += "&override_name=&override_options=";
		}
		awc.require({url: config_url , onprogress: progressTracker})
			.then(function(options_data) {
				var json_body = JSON.parse(options_data.body)
				var options = json_body.message;
				//awc.debug.log(options)
				if ( options.is_system_user ) {
					$('body').addClass('system-user');
				}

				var images = [];

				for(var i in options.parts) {
		      var part = options.parts[i];
					if ( part.groups) {
			      for(var j in part.groups) {
			        var group = part.groups[j];
			        for(var k in group.variants) {
			          var variant = group.variants[k];
								//images.push(variant.thumbnail);
			        }
			      }
					} else if ( part.is_gallery ) {
						for(var j in part.gallery) {
							var variant = part.gallery[j];
							images.push(variant.image);
							images.push(variant.thumbnail);
						}
					}
		    }

				//awc.debug.log("images", images)
				$(images).preload();
				return options_data;
			});
		awc.require({ url: '/assets/css/jhaudio3d.css', onprogress: progressTracker})

		$(this).click(function() {
			// avoid kicking off widget multiple times on multiple clicks
			if ( $(this).data('initialized') ) {
				return;
			}
			$(this).data('initialized', true);

			$splash.fadeIn('fast');

			var $this = $(this);
			var designer_options = null;
			var default_item = null;
			var $parent = $($this.attr('data-target'));
			$parent.addClass('active');
			$(this).addClass('active');

			// wait for 3d designer lib load if not already loaded
			awc.require({ url: '/assets/jhaudio3d/js/libs/gif.js', onprogress: progressTracker})
				.then(function() {
					return awc.require({url: '/assets/js/jhaudio3d.js', onprogress: progressTracker, nocache: 1})
				})
				.then(function() {
					// wait for options data if not already loaded.
					return awc.require({url: config_url, onprogress: progressTracker})
				})
				.then(function(options_data) { // bof - data parsing and process
					// store designer options
					var json_body = JSON.parse(options_data.body)
					designer_options = json_body.message

					// find default item selection
					for(var i in designer_options.items) {
						var item = designer_options.items[i];
						if ( item.item_code == default_item_code ) {
							default_item = item;
						}
					}
					designer_options.editing = jh3d.getParameterByName("edit")

					// wait for template if not already loaded.
					return cart.template(tpl_name).promiseReady()
				}) // eof - data parsing and process
				.then(function(tpl) { // bof - engine setup
					var $designer = $('<div class="designer-container"></div>');
					$designer.html(tpl.beginRender(designer_options));
					$parent.append($designer);
					$designer.hide();
					$designer.css({opacity: 0});

					$designer.prev().fadeOut('slow', function() {

						var $viewer = $designer.find('.jhaudio3d-viewer');
						if ( $viewer.length == 0 ) {
							return;
						}

						var $specs_container = $designer.find('.part-content.specs .group-content .content[data-template]');
						//awc.debug.log("Spec template", $specs_container, $specs_container.attr('data-template'));

						var instance = new jh3d.App({
							container: $viewer.get(0),
							widget: $designer,
							specs_container: $specs_container,
							specs_tpl: cart.template($specs_container.attr('data-template')),
							invoice_specs_tpl: cart.template($specs_container.attr('data-invoice-template')),
							options: designer_options,
							default_item: default_item,
							show_fps: show_fps,
							onInit: function() {
								$this.addClass('loaded');
							}
						});

						instance.build_widget();
						instance.show(function() {
							$splash.fadeOut('fast');
						});
						jh3d_instances.push(instance)

					});


					return tpl.endRender();

				}); // eof - engine setup

		}); // eof - $(this).click(function() {
			if ( cart.tag ) {
				// force loading 3d designer when a tag is used to override design id
				$(this).click();
			}

	}); // eof $('[data-jhaudio3d]:not(binded)').each(function() {
});
